import { CopilotChat } from "@/components/copilot/CopilotChat";

export default function Portfolio() {
  return (
    <div className="flex-1 space-y-4 px-6 py-6">
      
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Portfolio Analysis</h1>
        <p className="text-muted-foreground">
          Deep portfolio analytics, performance attribution, and risk metrics
        </p>
      </div>

      <CopilotChat tab="portfolio" />
    </div>
  );
}
